<script>
import {useRoute} from "vue-router";
import {ref, watch} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import L from "leaflet"
import "leaflet-extra-markers"
import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css"
import "leaflet/dist/leaflet.css"
import {useStore} from "vuex";
import {Geolocation} from "@capacitor/geolocation";
import swal from "sweetalert2";
import {AndroidSettings, NativeSettings} from "capacitor-native-settings";
import {Device} from "@capacitor/device";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import router from "@/router";

export default {
  name: "CategoryWorker",
  components: {BottomNavigation, LoadingPage},
  setup() {

    let store = useStore()

    let loading = ref(false)
    let page = ref('workers')

    let params = useRoute().params.type
    let filter = ref({
      state_id: null,
      city_id: null,
      radio: null,
    })

    if (store.state.filter.workers !== null) filter.value = FreeWorld.PinkMan(store.state.filter.workers, 'de')

    let country = ref(FreeWorld.PinkMan(store.state.country, 'de'))
    let city = ref([])

    let workers = ref([])
    let search = []
    let input_search = ref('')

    let lat = null
    let long = null


    watch(() => input_search.value, () => {
      workers.value = []
      search.forEach((item) => {
        if (item.name.includes(input_search.value)) workers.value.push(item)
      })
      if (page.value === 'map') add_marker()
    })


    function get_category(action) {
      let data = {
        action: params
      }

      if (action === 'delete') {
        filter.value = {
          state_id: null,
          city_id: null,
          radio: null,
        }
        store.commit('set_filter_workers', 'delete')
      }

      if (filter.value.state_id !== null && filter.value.city_id !== null) {
        data.state_id = filter.value.state_id
        data.city_id = filter.value.city_id
        chang_states('filter')
      } else {
        filter.value.state_id = null
        filter.value.city_id = null
      }
      if (filter.value.radio === 'favorite') data.best_rate = 1
      if (filter.value.radio === 'location') {
        if (lat === null && long === null) {
          get_location().then(() => {
            data.best_local = 1
            data.user_lat = lat
            data.user_lang = long
          }).catch(() => {
            Swals.Warning('ابتدا موقعیت مکانی دستگاه خود را روشن کنید!')
            filter.value.radio = null
            return false
          })
        } else {
          data.best_local = 1
          data.user_lat = lat
          data.user_lang = long
        }
      }

      filter.value.radio !== null || filter.value.state_id !== null ? store.commit('set_filter_workers', filter.value) : store.commit('set_filter_workers', 'delete')

      loading.value = true
      FreeWorld.Heisenberg(data, 'all_worker', true).then((res) => {
        loading.value = false
        workers.value = res.data
        search = res.data
        page.value = 'workers'
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_category)
      })
    }

    get_category()

    function chang_states(action) {
      country.value.forEach((item) => {
        if (item.id === filter.value.state_id) {
          city.value = item.city
          if (action !== 'filter') filter.value.city_id = city.value[0].id
          return false
        }
      })
    }


    // ****** map ******

    let map
    let marker = L.ExtraMarkers.icon({
      shape: 'circle',
    })
    let my_marker = L.ExtraMarkers.icon({
      shape: 'circle',
      markerColor: 'cyan'
    })
    let center_map
    let check_Permissions = false

    async function load_map() {

      try {
        await get_location().then(() => {
          center_map = [lat, long]
          check_Permissions = true
        }).catch((e) => {
          center_map = [35.699736801550074, 51.33777700121453]
          Swals.Warning(e)
        })
      } catch (e) {
        center_map = [35.699736801550074, 51.33777700121453]
      }


      page.value = 'map'
      setTimeout(() => {
        map = L.map('map').setView(center_map, 13)
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)
        map.setView(center_map, 13)
        add_marker()
      }, 100)
    }

    function add_marker() {
      map.eachLayer(function (layer) {
        if (layer instanceof L.Marker) {
          map.removeLayer(layer);
        }
      });

      // مارکر برای موقعیت کاربر
      if (check_Permissions) {
        L.marker([lat, long], { icon: my_marker })
            .addTo(map)
            .bindPopup(`<span class="font-5 font-bold">موقعیت شما</span>`, { autoClose: false })
            .openPopup();
      }

      // مارکر برای هر کارگر
      workers.value.forEach((item) => {
        const workerMarker = L.marker([item.lat, item.lang], { icon: marker })
            .addTo(map)
            .bindPopup(`<span class="font-5 font-bold">${item.name}</span>`, { autoClose: false })
            .openPopup();

        // رویداد کلیک برای هر مارکر کارگر
        workerMarker.on('click', function () {
          router.push({name:'DetailsWorker' , params:{id:`${item.id}`}})
        });

        map.setView([item.lat, item.lang], 13);
      });
    }

    function FlyTo(select_lat, select_long) {
      map.flyTo([select_lat, select_long], 13)
      document.body.style.pointerEvents = 'none'

      map.once("zoomend", () => {
        document.body.style.pointerEvents = 'auto'
      });
    }

    async function get_location(fly) {
      let deviceInfo = await Device.getInfo()

      try {
        return new Promise((resolve, reject) => {
          if (deviceInfo.platform === 'android') {
            Geolocation.checkPermissions().then((res) => {

              if (res.location === 'granted') {
                Geolocation.getCurrentPosition().then((pos) => {
                  center_map = [pos.coords.latitude, pos.coords.longitude]
                  lat = pos.coords.latitude
                  long = pos.coords.longitude
                  if (fly) FlyTo(pos.coords.latitude, pos.coords.longitude)
                  resolve('ok');
                }).catch(() => {
                  if (fly) Swals.Warning('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
                  reject('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
                })

              } else {
                Geolocation.requestPermissions();
                reject('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
                if (fly) Swals.Warning('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
              }

            }).catch(() => {
              swal.fire({
                icon: 'question',
                iconColor: '#FE4040',
                text: 'موقعیت یاب دستگاه روشن شود؟',
                width: 250,
                color: 'var(--font)',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                confirmButtonColor: '#1ccf98',
                cancelButtonColor: '#ff5b5b',
                background: 'white',
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await NativeSettings.openAndroid({
                    option: AndroidSettings.Location,
                  });
                  resolve('ok')
                } else {
                  if (fly) Swals.Warning('ابتدا موقعیت مکانی دستگاه را روشن کنید!')
                  reject('ابتدا موقعیت مکانی دستگاه را روشن کنید!')
                }
              })
            })

          } else {
            navigator.geolocation.getCurrentPosition((pos) => {
              center_map = [pos.coords.latitude, pos.coords.longitude]
              lat = pos.coords.latitude
              long = pos.coords.longitude
              if (fly) FlyTo(pos.coords.latitude, pos.coords.longitude)
              resolve('ok');
            }, () => {
              if (fly) Swals.Warning('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
              reject('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
            });
          }
        })
      } catch (e) {
        Swals.Fault('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
      }
    }


    return {
      params,
      input_search,
      workers,
      loading,
      page,
      load_map,
      filter,
      chang_states,
      country,
      city,
      get_category,
      get_location,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div v-if="page === 'workers'" id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p v-if="params === 'repairman'" class="text-white font-bold font-4">تعمیر کاران</p>
      <p v-if="params === 'service'" class="text-white font-bold font-4">سرویس کاران</p>
      <p v-if="params === 'repair-service'" class="text-white font-bold font-4">تعمیر کاران - سرویس کاران</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div style="top:-1.5rem"
           class="d-flex z-1 py-2 align-items-center justify-content-between mb-4 rounded-pill position-sticky max_width w-100">
        <div class="d-flex align-items-center rounded-pill shadow-custom p-3 w-80 bg-white">
          <img class="icon-size-3" src="../assets/img/icon-search.svg" alt="">
          <input v-model="input_search" class="border-0 text-center font-5 w-100 bg-white" type="text"
                 placeholder="جستجوی عنوان تعمیرکار">
        </div>

        <div class="position-relative">
          <p v-if="filter.radio !== null || filter.state_id !== null"
             class="p-2 rounded-pill bg-danger position-absolute top-0 start-0 z-1"></p>
          <img @click="page = 'filters'" class="icon-size-6 icon_border icon_shadow"
               src="../assets/img/icon-setting.svg" alt="">
        </div>
      </div>


      <div v-if="workers.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in workers" :key="item.id"
           class="animate__animated animate__fadeIn rounded-4 shadow-custom p-2 d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center">
          <img v-if="item.pic !== null" class="profile icon_border ms-2" :src="item.pic" alt="">
          <img v-else class="profile icon_border ms-2" src="../assets/img/defult-profile.svg" alt="">

          <div class="d-flex flex-column justify-content-between">
            <p v-if="item.users_type_id === 2" class="font-6">سرویس کار</p>
            <p v-if="item.users_type_id === 3" class="font-6">تعمیر کار</p>
            <p v-if="item.users_type_id === 4" class="font-6">تعمیر کار - سرویس کار</p>
            <p class="font-4 text-color font-bold">{{ item.name }}</p>
            <p class="font-6">{{ item.state }} - {{ item.city }}</p>
          </div>
        </div>

        <div class="d-flex flex-column w-20">
          <div class="rounded-4 bg-custom d-flex align-items-center p-2 mb-2">
            <img class="icon-size-1 ms-2" src="../assets/img/icon-star.svg" alt="">
            <span class="font-5 text-color font-bold">{{ item.rate }}</span>
          </div>

          <router-link :to="{name:'DetailsWorker',params:{id:item.id}}"
                       class="bg-green text-decoration-none text-color font-5 text-center rounded-4 font-bold px-2 py-1">
            جزئیات
          </router-link>
        </div>
      </div>


      <br>
      <br>
      <br>
      <br>

      <div style="bottom: 13%" class="position-fixed max_width">
        <p @click="load_map" class="font-5 text-white rounded-pill text-center font-bold p-3 bg-color-liner">مشاهده روی
          نقشه</p>
      </div>

      <BottomNavigation></BottomNavigation>
    </div>
  </div>

  <div v-if="page === 'map'" id="main" :class="loading ? 'activeClass':''" class="">
    <div style="z-index: 500;"
         class="d-flex align-items-center justify-content-between position-fixed top-0 max_width w-100 mt-5 px-4">
      <div class="d-flex align-items-center rounded-pill shadow-custom p-3 w-80 bg-main">
        <img class="icon-size-3" src="../assets/img/icon-search.svg" alt="">
        <input v-model="input_search" class="border-0 text-center font-5 w-100 bg-main" type="text"
               placeholder="جستجوی عنوان تعمیرکار">
      </div>

      <div class="position-relative">
        <p v-if="filter.radio !== null || filter.state_id !== null"
           class="p-2 rounded-pill bg-danger position-absolute top-0 start-0 z-1"></p>
        <img @click="page = 'filters'" class="icon-size-6 icon_border icon_shadow" src="../assets/img/icon-setting.svg"
             alt="">
      </div>
    </div>

    <div style="height: 100vh" id="map" class="w-100"></div>

    <div style="z-index: 500;" class="max_width position-fixed bottom-10">
      <img @click="get_location(true)" class="icon-size-7 me-3" src="../assets/img/icon-my-location.png" alt="">
    </div>

    <div style="z-index: 500;" class="d-flex justify-content-center max_width position-fixed bottom-1 mb-4 w-100">
      <p @click="page = 'workers'" class="font-4 text-color font-bold p-3 shadow-custom bg-custom rounded-pill">بستن
        نقشه</p>
    </div>
  </div>

  <div v-if="page === 'filters'" id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img @click="page = 'workers'" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">فیلتر ها</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div class="d-flex justify-content-end mb-4">
        <img @click="get_category('delete')" class="icon_shadow icon-size-5" src="../assets/img/icon-bin.svg" alt="">
      </div>

      <div class="d-flex justify-content-between rounded-pill bg-white shadow-custom p-3 mb-2">
        <p class="font-4 text-color">استان</p>

        <select v-model="filter.state_id" @change="chang_states" class="border-0 bg-white w-35">
          <option :value="null">انتخاب کنید</option>
          <option v-for="item in country" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="d-flex justify-content-between rounded-pill shadow-custom bg-white p-3 mb-2">
        <p class="font-4 text-color">شهر</p>

        <select v-model="filter.city_id" class="border-0 bg-white w-35">
          <option :value="null">انتخاب کنید</option>
          <option v-for="item in city" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="d-flex justify-content-between rounded-pill shadow-custom p-3 mb-2">
        <label for="closest" class="font-4 text-color w-90">نزدیک ترین ها</label>

        <input v-model="filter.radio" id="closest" name="filter" value="location" type="radio" class="">
      </div>

      <div class="d-flex justify-content-between rounded-pill shadow-custom p-3 mb-2">
        <label for="Popular" class="font-4 text-color w-90">محبوب ترین ها</label>

        <input v-model="filter.radio" id="Popular" name="filter" value="favorite" type="radio" class="">
      </div>

      <div class="d-flex justify-content-center w-100 max_width position-fixed bottom-5">
        <p @click="get_category" class="bg-color-liner rounded-pill py-3 px-5 text-white font-4">اعمال</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.profile {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}
</style>